// extracted by mini-css-extract-plugin
export var hero = "QKMPZ2oEcLYBqtYaEZW5";
export var root = "UzFfjJtrTT5KRA99OT6u";
export var title1 = "k_VadbPPFiO7jpb_kWsh";
export var title2 = "PB4bNQgHmYWxlZpRKcjW";
export var title3 = "FUEPlXjTWFBs31H2VvtV";